export interface PendingExpenseFilters {
  readonly filter: string;
}

/** Query keys for the pending-expense list (filter object embedded for stable partial matches). */
export const pendingExpenseKeys = {
  all: () => ['pending-expense'] as const,
  lists: () => [...pendingExpenseKeys.all(), 'list'] as const,
  list: (filters: PendingExpenseFilters) => [...pendingExpenseKeys.lists(), filters] as const,
} as const;
